import { ROUTE_NAME } from '@constants';

const courseIntroduction = {
  path: '/course-introduction',
  redirect: '/course-introduction/course-features',
  name: ROUTE_NAME.CourseFeatures,
  meta: {
    // isDesktop: true,
    breadcrumb: true,
    breadcrumbName: '코스안내',
    navMenu: true,
    description: '송추컨트리클럽의 코스특징을 안내해드립니다.',
  },
  children: [
    {
      name: ROUTE_NAME.CourseFeatures,
      path: 'course-features',
      component: () => import('@views/course-information/CourseFeatures.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '코스특징',
      },
    },
    // {
    //   name: ROUTE_NAME.CourseTips,
    //   path: 'course-tips',
    //   component: () => import('@views/course-information/CourseTips.vue'),
    //   meta: {
    //     breadcrumb: true,
    //     breadcrumbName: '코스공략',
    //   },
    // },
    {
      name: ROUTE_NAME.WestCourse,
      path: 'west-course',
      component: () => import('@views/course-information/WestCourse.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: 'WEST COURSE',
      },
    },
    {
      name: ROUTE_NAME.EastCourse,
      path: 'east-course',
      component: () => import('@views/course-information/EastCourse.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: 'EAST COURSE',
      },
    },
  ],
};

export default courseIntroduction;
